import React, { useState } from "react";

interface TruncateTextProps {
	text: string;
	length: number;
}

const TruncateText: React.FC<TruncateTextProps> = ({ text, length }) => {
	const [isExpanded, setIsExpanded] = useState(false);

	const toggleExpand = () => setIsExpanded(!isExpanded);

	if (!text) return null;

	if (text.length <= length || isExpanded) {
		return (
			<>
				{text}
				{text.length > length && (
					<button onClick={toggleExpand} className="text-blue-500 ml-1">
						Show Less
					</button>
				)}
			</>
		);
	}

	return (
		<>
			{text.substring(0, length)}...
			<button onClick={toggleExpand} className="text-blue-500 ml-1">
				Read More
			</button>
		</>
	);
};

export default TruncateText;
